module.exports = __webpack_public_path__ + "static/media/bt.ad0691b2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bt.svg
// module id = 2054
// module chunks = 0